import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import supportDeskService from '../../services/supportDeskService';

const initialState = {
  tickets: [],
  ticket: null,
  isLoading: false,
  error: null,
};

export const fetchTickets = createAsyncThunk(
  'supportTickets/fetchTickets',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await supportDeskService.getTickets(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch tickets');
    }
  }
);

const supportTicketSlice = createSlice({
  name: 'supportTickets',
  initialState,
  reducers: {
    clearTicketError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTickets.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTickets.fulfilled, (state, action) => {
        state.isLoading = false;
        state.tickets = action.payload.results || action.payload;
        state.error = null;
      })
      .addCase(fetchTickets.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to fetch tickets';
      });
  },
});

export const { clearTicketError } = supportTicketSlice.actions;
export default supportTicketSlice.reducer;
